type UsersAPIUrlsKeys = 'userInfo';

export const usersAPIUrls: Record<UsersAPIUrlsKeys, `/${string}`> = {
  userInfo: '/get-user-info',
} as const;
